import type { BoxProps } from '@shopify/polaris';

import { Box } from '@shopify/polaris';

interface GBoxCardProps extends BoxProps {
  children: React.ReactNode;
}

export const G_BOX_CARD_DEFAULT_PROPS: Pick<
  BoxProps,
  'padding' | 'background' | 'borderRadius' | 'shadow' | 'outlineWidth' | 'outlineColor'
> = {
  padding: '400',
  background: 'bg-fill',
  borderRadius: '300',
  shadow: '200',
  outlineWidth: '0165',
  outlineColor: 'border-secondary',
};

export const GBoxCard = ({ children, ...props }: GBoxCardProps) => {
  return (
    <Box {...G_BOX_CARD_DEFAULT_PROPS} {...props}>
      {children}
    </Box>
  );
};
